module.exports = __webpack_public_path__ + "static/media/viug.4bab53db.png";